import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LinearProgress, Stack, Tooltip } from '@mui/material';
import { useContext } from 'react';
import { msToTime } from '../../../helpers/format';
import { TypeIcons } from '../../../Iconography';
import { ProcessReceptionAreaRequestStatus } from '../CloudSideTypes';
import { NetworkCoverageContext } from '../NetworkCoverageContext';
export const RequestStatusIndicator = ({ withProgressBar }) => {
    const { state: { requestStatusMap }, } = useContext(NetworkCoverageContext);
    let pendingStatus = 0;
    let currentStatus = 0;
    const totalStatus = Object.values(requestStatusMap).length;
    Object.entries(requestStatusMap).forEach(([_, v]) => {
        if (ProcessReceptionAreaRequestStatus.REQUESTED < v.status)
            pendingStatus++;
        if (ProcessReceptionAreaRequestStatus.PENDING < v.status)
            currentStatus++;
    });
    const progress = (currentStatus / totalStatus) * 100;
    const pending = (pendingStatus / totalStatus) * 100;
    return (_jsxs(Stack, { gap: 1, children: [_jsx(Stack, { direction: "row", flexWrap: "wrap", children: Object.entries(requestStatusMap).map(([_, v]) => {
                    const icon = GetIconFromStatus(v);
                    return icon;
                }) }), withProgressBar && (_jsx(LinearProgress, { variant: "buffer", value: progress, valueBuffer: pending, sx: { maxWidth: `${Object.values(requestStatusMap).length * 1.5}em` } }))] }));
};
const colorMap = {
    [ProcessReceptionAreaRequestStatus.REQUESTED]: 'disabled',
    [ProcessReceptionAreaRequestStatus.PENDING]: 'info',
    [ProcessReceptionAreaRequestStatus.FAILED]: 'error',
    [ProcessReceptionAreaRequestStatus.NO_DATA]: 'warning',
    [ProcessReceptionAreaRequestStatus.READY]: 'success',
};
const GetIconFromStatus = (notification) => {
    const { GeoObject, status, reason, durationMs, resultSetSize } = notification;
    const { type, name, sk } = GeoObject;
    const color = colorMap[status];
    let title = `${name}: `;
    switch (status) {
        case ProcessReceptionAreaRequestStatus.REQUESTED:
            title += 'Pending';
            break;
        case ProcessReceptionAreaRequestStatus.PENDING:
            title += 'Processing';
            break;
        case ProcessReceptionAreaRequestStatus.FAILED:
            title += 'Failed';
            break;
        case ProcessReceptionAreaRequestStatus.NO_DATA:
            title += 'No data';
            break;
        case ProcessReceptionAreaRequestStatus.READY:
            title += 'Ready';
            break;
    }
    if (reason)
        title += `, ${reason}`;
    if (resultSetSize && durationMs)
        title += ` (${resultSetSize} readings, took ${msToTime(durationMs)})`;
    return (_jsx(Tooltip, { title,
        children: type === 'Area' ? (_jsx(TypeIcons.Area, { color }, `requestStatusIcon_${sk}`)) : type === 'Place' ? (_jsx(TypeIcons.Place, { color }, `requestStatusIcon_${sk}`)) : (_jsx("div", {})) }, sk));
};
